import { tryAutoRefresh, useAuthStore } from '@neuroforge/shared/client'

/**
 * Block only protected guards while refresh is pending. The callback route owns
 * its OAuth fragment and must never race with a background cookie refresh.
 */
export async function bootstrapAcademySession(
  pathname: string = window.location.pathname,
  refresh: () => Promise<boolean> = tryAutoRefresh,
): Promise<void> {
  if (pathname.replace(/\/+$/, '') === '/auth/callback') return

  useAuthStore.getState().setLoading(true)
  try {
    await refresh()
  } catch {
    // A failed refresh is anonymous; the protected guards will handle login.
    useAuthStore.getState().logout()
  } finally {
    useAuthStore.getState().setLoading(false)
  }
}
